import React from 'react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

import { ApplicationState } from '@app/store';
import { useCrematory } from '@app/hooks/Crematory/useCrematory';
import { RoleManager } from '@app/services/RoleManager';

interface DateViewProps {
	date: number;
	format?: string;
}

export const DateView: React.FC<DateViewProps> = ({ date, format }: DateViewProps) => {
	const user = useSelector((state: ApplicationState) => state.login.user);
	const crematory = useCrematory();
	const currentFormat = user && RoleManager.for(user.role).isAdmin() ? user.localeUserPreferences?.dateFormat : crematory?.dateFormat;

	return <span>{dayjs(date).format(format ?? currentFormat)} </span>;
};
